import { render, staticRenderFns } from "./check_fee_add.vue?vue&type=template&id=3a8c3de4&scoped=true&"
import script from "./check_fee_add.vue?vue&type=script&lang=js&"
export * from "./check_fee_add.vue?vue&type=script&lang=js&"
import style0 from "./check_fee_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c3de4",
  null
  
)

export default component.exports